module.exports = __webpack_public_path__ + "img/15.56759ea7.png";